import { useLocation, useNavigate } from "react-router-dom";
import {
  getStoreLocalData,
  getUserData,
  setSelectedSearchOrderType,
} from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "../../SchedularModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import StoreMenu from "../../StoreMenu";
import ButtonLink from "../../../ButtonLink";
import useLoyaltyPointLog from "../../StoreContext/useLoyaltyPointLog";
import {
  getCustomerLoyaltyPointCheckDiscount,
  getCustomerLoyaltyPointLog,
} from "../../../services/LoyaltyPoint/LoyaltyPoint";
import AdminMenu from "../../AdminMenu";

const { innerWidth: width, innerHeight: height } = window;

const CustomerLoyaltyPointCashLog = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { storeCustomerId, loyaltyPoint, storeIdValue } = location.state || {};
  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const userRole = userProfileRole;

  const storeId = userRole === "BY_STORE" ? storeData.id : storeIdValue;

  const { storeLocalData } = getStoreLocalData();

  let brandId = brandProfileData.id;
  const {
    sortingData,
    setSortingData,
    schedularDate,
    setSchedularDate,
    loyaltyPointLogData,
    setLoyaltyPointLogData,
    loyaltyPointCashLogData,
    setLoyaltyPointCashLogData,
    page,
    setPage,
    useEffectCall,
    setUseEffectCall,
  } = useLoyaltyPointLog();

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loyaltyPointCheckDiscount, setLoyaltyPointCheckDiscount] = useState(
    {}
  );

  const initializeVariable = () => {
    // setLoyaltyPointLogData([]);
    setLoyaltyPointCashLogData([]);
  };

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleSortData = () => {
    setUseEffectCall(true);
    setPage(0);
    setSortingData(!sortingData);
  };

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchPackageLogData = (data) => {
    setLoading(true);
    getCustomerLoyaltyPointLog({
      ...data,
      limit: 20,
      offset: page * 20, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (page === 0) {
            // setLoyaltyPointLogData(Res); // Reset with fresh data
            setLoyaltyPointCashLogData(Res)
          } else {
            // setLoyaltyPointLogData((prevData) => {
            //   const existingIds = new Set(prevData.map((item) => item.id));
            //   const newUniqueData = Res.filter(
            //     (item) => !existingIds.has(item.id)
            //   );
            //   return [...prevData, ...newUniqueData];
            // });
            setLoyaltyPointCashLogData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter(
                (item) => !existingIds.has(item.id)
              );
              return [...prevData, ...newUniqueData];
            });
          }
          setLoading(false);
          setLoadingSearch(false);
          setIsEndReached(Res.length < 20);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
      });
  };

  const fetchLoyaltyPointCheckDiscount = (data) => {
    getCustomerLoyaltyPointCheckDiscount(storeId, storeCustomerId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setLoyaltyPointCheckDiscount(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [storeId],
    brandId: brandId,
    // startDate:startDate,
    // endDate:endDate,
    sortOrder: "desc",
    sortBy: "id",
    storeCustomerId: storeCustomerId,
    conversionType : "CASH",
  };
  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      requestData.sortOrder = sortingData ? "asc" : "desc";
      setPage(0);
      fetchPackageLogData(requestData);
    }
  }, [schedularDate, sortingData]);

  useEffect(() => {
    fetchPackageLogData(data);
    const loyaltyPointCheckDiscountData = {
      verificationRequested: false,
    };
    fetchLoyaltyPointCheckDiscount(loyaltyPointCheckDiscountData);
  }, []);

  useEffect(() => {
    if (page > 0) fetchPackageLogData(requestData);
  }, [page]);

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };

  const itemTemplate = (data) => {
    const formattedCreatedDate = formatDate(data.createdDate);
    return (
      <Accordion>
        <AccordionTab
          key={data.id} // Use a more unique key like data.id
          header={`${formattedCreatedDate} -> Conversion Unit : ${
            data.conversionUnit
          } | ${
            data?.conversionType === "POINT"
              ? "Loyalty Point Awarded"
              : "Discount"
          } : ${data.conversion} | ${data.invoiceNo || " "}`}
          style={{
            "--backgroundColor-AccordionTab": "#3EB3E1",
          }}
        >
          <div
            className="cursor-pointer"
            onClick={() =>
              navigate("/OrdersGarmentInfo", {
                state: {
                  bookingOrderId: data.orderId,
                  storeCustomerId: data.storeCustomer.id,
                  navigateThrough: "GoBack",
                },
              })
            }
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Conversion Type:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionType}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Create On:</p>
                <p className="text-lg font-bold capitalize">
                  {formatDate(data?.createdDate)}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Conversion Unit:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionUnit}
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  {data?.conversionType === "POINT"
                    ? "Bill Amount"
                    : "Point Converted"}{" "}
                  :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversionTo}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  {data?.conversionType === "POINT"
                    ? "Loyalty Point Awarded"
                    : "Discount"}{" "}
                  :
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.conversion}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice No:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.invoiceNo || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/Customer-Loyalty-Point-Log", {
                          state :{
                            storeCustomerId:storeCustomerId,
                            loyaltyPoint:loyaltyPoint,
                            storeId:storeId
                        }
                        })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Loyalty Point Redeem Log
              </p>
            </div>
          </div>
          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            )}
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
        <div className="flex justify-content-center">
        <h3>
            Loyalty Point Discount : {storeLocalData?.currencySymbol} {loyaltyPointCheckDiscount.amount}
              </h3>
        </div>
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : loyaltyPointCashLogData?.length > 0 ? (
          <div>
          <div >
            <div>
              <DataScroller
                value={loyaltyPointCashLogData}
                itemTemplate={itemTemplate}
                rows={loyaltyPointCashLogData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 100}
                loader
                // footer={footer}
              />
            </div>
            </div>
             
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Loyalty Point Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 10, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>

        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
         {userRole === "BY_STORE" ? (
                  <StoreMenu setVisible={setVisible} visible={visible} />
                ) : (
                  <AdminMenu setVisible={setVisible} visible={visible} />
                )}
        <ButtonLink />
      </div>
    </div>
  );
};

export default CustomerLoyaltyPointCashLog;
